import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ThemeProvider } from "@libs/design";
import { FontFaces } from "@libs/design/theme";

import App from "./App.tsx";

import "@libs/translation-service-provider";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <FontFaces />
      <App />
    </ThemeProvider>
  </StrictMode>
);
